/* custom-logo.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VUofl%7Bheight%3A2pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvD8fU6%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0GTcwR1Y8M%7Bmargin-inline-start%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6o126%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3gzVzLJovG%3Aactive%7Bbackground-color%3Avar(--ds-background-neutral-subtle-pressed%2C%230b120e24)%21important%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6JxD8%3Ahover%7Bbackground-color%3Avar(--ds-top-bar-button-background-hovered)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3gzVzL8abp%3Aactive%7Bbackground-color%3Avar(--ds-top-bar-button-background-pressed)%21important%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL41Y8M%7Bpadding-inline%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LETLXoWWg%20img%7Bheight%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1PTmduOLYo%20img%7Bmax-width%3Ainherit%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3G0Ib8gIor%20img%7B-o-object-fit%3Acontain%3Bobject-fit%3Acontain%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlN91d%7Bmax-width%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIoWWg%7Bmin-width%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXloWWg%7Bmax-width%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04iPvdi%7Bbox-sizing%3Acontent-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A64rem)%7B._2rc81eYbGa._2rc81eYbGa%7Bdisplay%3Anone%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbYbGa%7Bdisplay%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlsz7G%7Bmax-width%3A20pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A64rem)%7B._2rc81eQ4SZ._2rc81eQ4SZ%7Bdisplay%3Aflex%7D%7D");
import React, { useEffect, useRef } from 'react';
import { cx } from '@compiled/react';
import type { LogoProps } from '@atlaskit/logo/types';
import { Anchor } from '@atlaskit/primitives/compiled/anchor';
import { useIsFhsEnabled } from '../../fhs-rollout/use-is-fhs-enabled';
import { useHasCustomTheme } from '../themed/has-custom-theme-context';
import { LogoRenderer } from './logo-renderer';
const anchorStyles = {
  root: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUofl",
  customLogoBorderRadius: "_0bjKvD8fU6",
  newMargin: "_0GTcwR1Y8M",
  newInteractionStates: "_1eOmH6o126 _3gzVzLJovG",
  newInteractionStatesCustomTheming: "_1eOmH6JxD8 _3gzVzL8abp"
};
const sharedIconOrLogoContainerStyles = {
  root: "_4bt5LAnQyn _2WAcuGnQyn _2Y7lL41Y8M _0LETLXoWWg _1PTmduOLYo _3G0Ib8gIor",
  withFullHeightSidebar: "_1EqgXlN91d _4ouGXIoWWg"
};
const iconContainerStyles = {
  root: "_3iDTPbQ4SZ _1EqgXloWWg _24h04iPvdi _2rc81eYbGa"
};
const logoContainerStyles = {
  root: "_3iDTPbYbGa _1EqgXlsz7G _24h04iPvdi _2rc81eQ4SZ"
};

/**
 * __Custom logo__
 *
 * Custom logo for the top navigation.
 *
 * To provide a responsive experience, it requires both a logo and an icon component.
 * The logo component will be used for large viewports, and the icon component will be used for small viewports.
 */
export const CustomLogo: ({
  href,
  logo,
  icon,
  onClick,
  label
}: {
  /**
   * Provide an accessible label, often used by screen readers.
   */
  label: string;
  /**
   * The URL to navigate to when the element is clicked.
   */
  href: string;
  /**
   * The logo component to render. It will be used for large viewports.
   */
  logo: (props: LogoProps) => JSX.Element;
  /**
   * The icon component to render. It will be used for small viewports.
   */
  icon: (props: LogoProps) => JSX.Element;
  /**
   * Handler called on click.
   */
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}) => JSX.Element = ({
  href,
  logo,
  icon,
  onClick,
  label
}: {
  /**
   * Provide an accessible label, often used by screen readers.
   */
  label: string;
  /**
   * The URL to navigate to when the element is clicked.
   */
  href: string;
  /**
   * The logo component to render. It will be used for large viewports.
   */
  logo: (props: LogoProps) => JSX.Element;
  /**
   * The icon component to render. It will be used for small viewports.
   */
  icon: (props: LogoProps) => JSX.Element;
  /**
   * Handler called on click.
   */
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}) => {
  const ref = useRef<HTMLAnchorElement>(null);
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      return;
    }
    if (!ref.current) {
      return;
    }
    const img = ref.current.querySelector('img');
    if (!img) {
      return;
    }

    /**
     * We want custom logo components to render the image as the immediate child
     */
    const hasExpectedStructure = img.parentElement?.parentElement === ref.current;
    /**
     * We want custom logo components to render only one image
     */
    const isOnlyChild = img.parentElement?.childElementCount === 1;
    if (!hasExpectedStructure || !isOnlyChild) {
      // eslint-disable-next-line no-console
      console.error('Custom logos should render only a single image tag with no wrappers.');
    }
    if (img.getAttribute('width') !== null || img.getAttribute('height') !== null || img.style.width !== '' || img.style.height !== '') {
      // eslint-disable-next-line no-console
      console.error('Do not set explicit dimensions on custom logo images. The container will resize the image to fit.');
    }
  }, []);
  const hasCustomTheme = useHasCustomTheme();
  const isFhsEnabled = useIsFhsEnabled();
  return <Anchor ref={ref} aria-label={label} href={href}
  // @ts-expect-error - non-standard values for `borderRadius` and the custom theming interaction states
  // eslint-disable-next-line @compiled/no-suppress-xcss
  xcss={cx(anchorStyles.root, anchorStyles.customLogoBorderRadius, anchorStyles.newMargin, hasCustomTheme ? anchorStyles.newInteractionStatesCustomTheming : anchorStyles.newInteractionStates)} onClick={onClick}>
			<div className={ax([sharedIconOrLogoContainerStyles.root, iconContainerStyles.root, isFhsEnabled && sharedIconOrLogoContainerStyles.withFullHeightSidebar])}>
				<LogoRenderer logoOrIcon={icon} />
			</div>
			<div className={ax([sharedIconOrLogoContainerStyles.root, logoContainerStyles.root, isFhsEnabled && sharedIconOrLogoContainerStyles.withFullHeightSidebar])}>
				<LogoRenderer logoOrIcon={logo} />
			</div>
		</Anchor>;
};